import { Difficulty, PhraseItem } from '../types/game';

export const PHRASE_LIBRARY: PhraseItem[] = [
  // EASY - Single words & short phrases
  { id: '1', phrase: 'BUTTERFLY', category: 'words', difficulty: 'easy' },
  { id: '2', phrase: 'SUNSHINE', category: 'words', difficulty: 'easy' },
  { id: '3', phrase: 'PINEAPPLE', category: 'words', difficulty: 'easy' },
  { id: '4', phrase: 'AVOCADO', category: 'words', difficulty: 'easy' },
  { id: '5', phrase: 'FIREWORKS', category: 'words', difficulty: 'easy' },
  { id: '6', phrase: 'CHOCOLATE', category: 'words', difficulty: 'easy' },
  { id: '7', phrase: 'LIGHTNING', category: 'words', difficulty: 'easy' },
  { id: '8', phrase: 'RAINBOW', category: 'words', difficulty: 'easy' },
  { id: '9', phrase: 'ASTRONAUT', category: 'words', difficulty: 'easy' },
  { id: '10', phrase: 'WATERFALL', category: 'words', difficulty: 'easy' },
  { id: '11', phrase: 'HIGH FIVE', category: 'sayings', difficulty: 'easy' },
  { id: '12', phrase: 'GOOD LUCK', category: 'sayings', difficulty: 'easy' },
  { id: '13', phrase: 'ICE CREAM', category: 'words', difficulty: 'easy' },
  { id: '14', phrase: 'SUPERSTAR', category: 'words', difficulty: 'easy' },
  { id: '15', phrase: 'ROLLERCOASTER', category: 'words', difficulty: 'easy' },

  // MEDIUM - Popular idioms & common phrases
  { id: '16', phrase: 'PIECE OF CAKE', category: 'idioms', difficulty: 'medium' },
  { id: '17', phrase: 'BREAK A LEG', category: 'idioms', difficulty: 'medium' },
  { id: '18', phrase: 'SPILL THE BEANS', category: 'idioms', difficulty: 'medium' },
  { id: '19', phrase: 'OUT OF THE BLUE', category: 'idioms', difficulty: 'medium' },
  { id: '20', phrase: 'BITE THE BULLET', category: 'idioms', difficulty: 'medium' },
  { id: '21', phrase: 'SILVER LINING', category: 'idioms', difficulty: 'medium' },
  { id: '22', phrase: 'SMOOTH SAILING', category: 'idioms', difficulty: 'medium' },
  { id: '23', phrase: 'DIME A DOZEN', category: 'idioms', difficulty: 'medium' },
  { id: '24', phrase: 'BACK TO SQUARE ONE', category: 'idioms', difficulty: 'medium' },
  { id: '25', phrase: 'ON THE FENCE', category: 'idioms', difficulty: 'medium' },
  { id: '26', phrase: 'BARKING UP THE WRONG TREE', category: 'idioms', difficulty: 'medium' },
  { id: '27', phrase: 'BURNING THE MIDNIGHT OIL', category: 'idioms', difficulty: 'medium' },
  { id: '28', phrase: 'LET THE CAT OUT OF THE BAG', category: 'idioms', difficulty: 'medium' },
  { id: '29', phrase: 'UNDER THE WEATHER', category: 'idioms', difficulty: 'medium' },
  { id: '30', phrase: 'HIT THE NAIL ON THE HEAD', category: 'idioms', difficulty: 'medium' },

  // HARD - Fun sayings, quotes & longer phrases
  { id: '31', phrase: 'ACTIONS SPEAK LOUDER THAN WORDS', category: 'sayings', difficulty: 'hard' },
  { id: '32', phrase: 'EVERY CLOUD HAS A SILVER LINING', category: 'sayings', difficulty: 'hard' },
  { id: '33', phrase: 'MAY THE FORCE BE WITH YOU', category: 'pop_culture', difficulty: 'hard' },
  { id: '34', phrase: 'YOU CANNOT JUDGE A BOOK BY ITS COVER', category: 'sayings', difficulty: 'hard' },
  { id: '35', phrase: 'THERE IS NO PLACE LIKE HOME', category: 'pop_culture', difficulty: 'hard' },
  { id: '36', phrase: 'TO INFINITY AND BEYOND', category: 'pop_culture', difficulty: 'hard' },
  { id: '37', phrase: 'KILL TWO BIRDS WITH ONE STONE', category: 'sayings', difficulty: 'hard' },
  { id: '38', phrase: 'FORTUNE FAVORS THE BOLD', category: 'sayings', difficulty: 'hard' },
  { id: '39', phrase: 'A PICTURE IS WORTH A THOUSAND WORDS', category: 'sayings', difficulty: 'hard' },
  { id: '40', phrase: 'WHEN IN ROME DO AS THE ROMANS DO', category: 'sayings', difficulty: 'hard' }
];

export function getRandomPhrase(difficulty: Difficulty = 'easy', excludeId?: string): PhraseItem {
  let pool = PHRASE_LIBRARY;
  if (difficulty !== 'easy' && difficulty !== 'medium' && difficulty !== 'hard') {
    pool = PHRASE_LIBRARY;
  } else {
    pool = PHRASE_LIBRARY.filter(p => p.difficulty === difficulty);
  }
  
  if (excludeId && pool.length > 1) {
    pool = pool.filter(p => p.id !== excludeId);
  }
  
  const randomIndex = Math.floor(Math.random() * pool.length);
  return pool[randomIndex] || PHRASE_LIBRARY[0];
}
